import { render } from "./DayProgramView.vue?vue&type=template&id=65e31d9f&scoped=true"
import script from "./DayProgramView.vue?vue&type=script&lang=js"
export * from "./DayProgramView.vue?vue&type=script&lang=js"

import "./DayProgramView.vue?vue&type=style&index=0&id=65e31d9f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e31d9f"]])

export default __exports__